import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const CourseIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 31.08 19.2",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 19.2),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    children: [/*#__PURE__*/jsx("path", {
      d: "m29.668 9.601-3.822-3.822-3.822 3.822"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 9.601V5.986A4.986 4.986 0 0 1 5.986 1H8.48a4.95 4.95 0 0 1 4.945 4.986v7.229a5.021 5.021 0 0 0 5.028 4.986h2.49a4.916 4.916 0 0 0 4.9-4.986V5.778"
    }), " "]
  });
};

export { CourseIcon };
//# sourceMappingURL=course.js.map
